import { Component } from '@angular/core';
import { NavController,LoadingController,ModalController, NavParams,ToastController } from 'ionic-angular';
import { Params } from '../params';
import * as firebase from 'firebase/app';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { IncidentsPage } from './incidents';

import * as moment from 'moment';
import '../../../node_modules/moment/locale/es';

import {NotificationsProvider} from "../../providers/notifications/notifications";


@Component({
  templateUrl: 'new.html' })
export class NewIncidentPage {
  customers : any;
  items = [];
  constructor(
    public modalCtrl: ModalController
  ){

    firebase.database().ref('/customers').once('value').then((snap)=>{
      const val = snap.val();
      this.customers = Object.keys(val).map(key => val[key]);
      this.initializeItems();
      if(this.items.length>100){this.items = this.items.splice(0,100);}
    });
  }

  initializeItems(){
    this.items = this.customers;
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (
          (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.lastname.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.rut.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.email.toLowerCase().indexOf(val.toLowerCase()) > -1)
        );
      })
    }
  }

  open(customer){
    let modal = this.modalCtrl.create(ModalNewIncidentPage, customer);
    modal.present();
  }
}
@Component({
  template: `
<ion-header>
  <ion-toolbar>
    <ion-title>
      Asignar incidencia a {{customer.name}}
    </ion-title>
    <ion-buttons end>
      <button ion-button [disabled]="!addForm.valid" (click)="save()">
        Guardar Incidencia
      </button>
  </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
  <form [formGroup]="addForm" (ngSubmit)="onSubmit(addForm)">
    <ion-item>
      <ion-label>Fecha de Ingreso</ion-label>
      <ion-datetime formControlName="datecreate" [max]="max" name="datecreate" displayFormat="DD MMMM YY" pickerFormat="DD MMMM YY" doneText="Aceptar"></ion-datetime>
    </ion-item>
    <ion-item>
        <ion-label>Tipo de Problema</ion-label>
        <ion-select formControlName="category" name="category">
          <ion-option *ngFor="let category of categories" [value]="categories.indexOf(category)">{{category}}</ion-option>
        </ion-select>
    </ion-item>
    <ion-item>
      <ion-label stacked>Descripción Incidencia</ion-label>
      <ion-textarea formControlName="description" name="description" rows="10"></ion-textarea>
    </ion-item>
      </form>
  </ion-list>
</ion-content>
`
})
export class ModalNewIncidentPage {
  addForm: FormGroup;
  customer;
  categories;
  match;
  max = String(moment().add(1, 'year').format("YYYY-MM-DD"));
  constructor(
    private builder: FormBuilder,
    private params : NavParams,
    private navCtrl : NavController,
    private loadingCtrl : LoadingController,
    public toastCtrl: ToastController,
    private notif : NotificationsProvider
  ) {
    firebase.database().ref('/incidents/categories').once('value')
      .then((snap1)=> {
        console.log("cat",snap1.val())
        this.categories = snap1.val();
      })
    firebase.database().ref('/incidents/match').once('value')
      .then((snap1)=> {
        this.match = snap1.val();
      });
    this.addForm = builder.group({
      'datecreate': [moment().format(), Validators.required],
      'description': ['', Validators.required],
      'category': ['', Validators.required]
    });
    this.customer = params.data;
  }

  save() {
    let tosave = this.addForm.value;
    tosave.origin = "web";
    tosave.datetime = firebase.database.ServerValue.TIMESTAMP;
    tosave.status = 0;
    tosave.owner = Params.md5(Params.USER_DATA.email);
    tosave.customer = Params.md5(this.customer.email);
     let loading = this.loadingCtrl.create({
       content: 'Guardando los cambios...'
     });


     loading.present();

    // this.correlative = this.db.object('/incidents/correlative');

    firebase.database().ref('/incidents/correlative').once('value')
      .then((snap1)=> {
        let val = snap1.val();
        console.log(val);
        let correlative = Number(val)+1;
        let mails_groups = [];
        if(this.match) mails_groups = this.match[tosave.category];

        /*
        for(let m=0;m<mails_groups.length;m++){
          firebase.database().ref('/groups/data/'+mails_groups[m]).once('value')
            .then((snap2)=> {
                if(snap2.exists()){
                  let mails = snap2.val();
                  let temp_mails = [];
                  for(let n=0;n<Object.keys(mails).length;n++){
                    if(mails[Object.keys(mails)[n]]) temp_mails.push(mails[Object.keys(mails)[n]]);
                  }
                  let obj = {
                    "category" : tosave.category,
                    "emails" : temp_mails,
                    "correlative" : correlative,
                    "title" : "Nueva Incidencia",
                    "content" : "Existe una nueva incidencia"
                  }
                  this.http.post("http://fitfood.cl/admin/emails/index.php",obj).subscribe(data => {
                    let msg = "Se han enviado emails correctamente";
                    if(!data["ok"]){
                      msg = "No se pudo enviar emails."+data["msg"];
                    }
                    let toast = this.toastCtrl.create({
                      message: msg,
                      duration: 3000
                    });
                    toast.present();
                  });
                }
            });
        }
        */
        let title = "Nueva incidencia #"+correlative;
        let text = Params.USER_DATA.name+" creó una incidencia en "+this.categories[tosave.category];

        this.notif.sendNotification(title,text);

        firebase.database().ref('incidents/data/'+correlative).set(tosave)
          .then(()=>{
            firebase.database().ref('/incidents/correlative').set(correlative);
            loading.dismiss();
            this.navCtrl.setRoot(IncidentsPage);
          })
      });

  }

}



// WEBPACK FOOTER //
// ./src/pages/incidents/create.ts